/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsProjectMonthlyCount } from '../models/ds-project-monthly-count';
import { BydModel } from '@sixense/byd-core-service';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsProjectMonthlyCountService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get a List of each month with a count of projects.
   *
   * @returns Observable<BydModel<DsProjectMonthlyCount>>
   */
  public getNbProjectByMonth(): Observable<BydModel<DsProjectMonthlyCount>> {
    this.path = '/projects/monthlycount';
    return this.getModels<DsProjectMonthlyCount>();
  }

  /**
   * Create DsProject instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsProjectMonthlyCount` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsProjectMonthlyCount {
    return new DsProjectMonthlyCount(jsonObject);
  }
}
